import React, { useEffect, useState } from 'react';
import { Navegation } from '../../Components/Navegation';
import { useParams } from "react-router-dom";
import Loader from '../../Components/Loader';
import { Button } from '../../Components/Button';
import GA from '../../GoogleAnalytics';
import ObraServices, { iObra } from '../../Services/ObraServices';
import './index.scss';
export const Obra = () => {

    const [obra, setObra] = useState<iObra>();
    const [loading, setLoading] = useState(false);
    const { id } = useParams<{id: string}>();

    useEffect(() => {
        setLoading(true)
        ObraServices.getById(id).then((result:any)=>{
            if(result.status === 200){
                const {data} = result.data;
                setObra(data);
                setLoading(false)
            }
        }).catch((err:any) => {console.log(err)});
    },[id]);

    return (
        <div className="p_obra">
            {!loading && obra ?
                <>
                    <GA.RouteTracker title={`Obra - ${obra.titular}`}/>
                    <Navegation title={obra.titular} theme={"work"}/>
                    <div className="p_obra__content">
                        <div className="p_obra__content_image">
                            <img src={`https://test.archi.pe/cdn/thumbs/obra/${obra.imagen}`}></img>
                        </div>
                        <div className="p_obra__content_info">
                            <p className="p_obra__content_info_date e-p2">{obra.fecha_epoca}</p>
                            <p className="p_obra__content_info_author e-p2">{obra.autor_nombre}</p>
                            <p className="p_obra__content_info_title e-p2">{obra.coleccionista}</p>
                            <p className="p_obra__content_info_dimension e-p2">17.3 x 12.3 cm</p>
                            <p className="p_obra__content_info_photographer e-p2">FOTOGRAFO: {obra.fotografo_nombre}</p>
                            <p className="p_obra__content_info_description e-p3 e-text-light">{obra.creditos_fotografia}</p>
                            <div className="p_obra__content_info_buttons">
                                <Button theme={"black"}>ADQUIRIR</Button>
                                <Button theme={"linear"}>RECURSOS PARA EL DOCENTE</Button>
                                <Button theme={"linear"}>RECURSOS PARA EL AULA</Button>
                            </div>
                            <div className="p_obra__content_info_tags">
                                {obra.descriptores_tematicos &&
                                    obra.descriptores_tematicos.map((item, index) =>{
                                    return (<a key={index} className="e-p2">{item}</a>)
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </>
                :
                <Loader/>
            }
        </div>
    )
}